var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "M15.56 15.32c.45-.45.84-.96 1.15-1.53.56-1 .87-2.34.87-3.56 0-3.82-3.26-6.73-7.08-6.73a6.62 6.62 0 0 0-6.75 6.73c0 3.83 2.93 7.13 6.75 7.13 1.32 0 2.72-.37 3.77-1.01.47-.3.9-.64 1.3-1.03Zm0 0L21 21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24);
export default __webpack_public_path__ + "static/media/search_24.16899debcd4d44c97c8f12ea14abb85f.svg";
export { ForwardRef as ReactComponent };